// extracted by mini-css-extract-plugin
export var modalPadding = "MediaGalleryModal-module--modalPadding--72843";
export var overlay = "MediaGalleryModal-module--overlay--9623c";